import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import smoothscroll from 'smoothscroll-polyfill'

// Register Service Worker
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js', {
      scope: '/',
      updateViaCache: 'none'
    }).then(registration => {
      // Check for updates
      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing;
        newWorker?.addEventListener('statechange', () => {
          if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
            // New update available
            window.location.reload();
          }
        });
      });

      // Check for updates periodically
      setInterval(() => {
        registration.update();
      }, 60 * 60 * 1000); // Check every hour
    }).catch(registrationError => {
      console.error('Service Worker registration failed:', registrationError);
    });
  });
}

// Kick off the polyfill
smoothscroll.polyfill();

createRoot(document.getElementById("root")!).render(<App />);
